import React from 'react';
import clsx from 'clsx';

import { DivPropsWithoutRef } from '../common/types';

export enum Size {
  small_3x = 'small_3x',
  small_2x = 'small_2x',
  small_x = 'small_x',
  small = 'small',
  medium = 'medium',
  medium_x = 'medium_x',
  large = 'large',
  large_x = 'large_x',
  large_2x = 'large_2x',
  large_3x = 'large_3x',
  large_4x = 'large_4x'
}

export interface SpaceProps extends Omit<DivPropsWithoutRef, 'size'> {
  /**
   * Размер Space (`small_3x`, `small_2x`, `small_x`, `small`, `medium`, `medium_x`, `large`, `large_x`, `large_2x`, `large_3x`, `large_4x`)
   */
  size?: Size;
  /**
   * Горизонтальный вариант
   */
  horizontal?: boolean;
  /**
   * Вертикальный вариант
   */
  vertical?: boolean;
}

export function Space({
  size = Size.medium,
  horizontal,
  vertical,
  className,
  ...props
}: SpaceProps) {
  return (
    <div
      className={clsx(className, 'hse-Space', {
        'hse-Space_horizontal': horizontal,
        'hse-Space_vertical': vertical,
        [`hse-Space_size_${size}`]: size
      })}
      {...props}
    />
  );
}

Space.Size = Size;
